const GLOSSARY_LIST = 'bfb/glossary/GLOSSARY_LIST';
const GLOSSARY_LIST_SUCCESS = 'bfb/glossary/GLOSSARY_LIST_SUCCESS';
const GLOSSARY_LIST_FAILED = 'bfb/glossary/GLOSSARY_LIST_FAILED';

export default {
  GLOSSARY_LIST,
  GLOSSARY_LIST_SUCCESS,
  GLOSSARY_LIST_FAILED,
};
